import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col} from '@modifi/ui'
import {fileEntryComponents, Context as DocumentContext} from '@modifi/plugin-documents'
import {Wrapper, FileNameWrapper, FileName} from './styles'

const {FileTypeIcon} = fileEntryComponents

const onClickStopPropagation = (e: React.UIEvent) => e.stopPropagation()

const propTypes = {
  fileId: PropTypes.string.isRequired,
  className: PropTypes.string,
  fileName: PropTypes.string,
  mimeType: PropTypes.string,
}
const defaultProps = {
  className: undefined,
  fileName: undefined,
  mimeType: undefined,
}

type FileEntryProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const FileEntry: React.FC<FileEntryProps> = ({fileId, className, fileName, mimeType}) => (
  <DocumentContext.Consumer>
    {({onDownloadFile}) => (
      <Wrapper
        className={className}
        data-ident="file-entry"
        data-file-id={fileId}
        data-file-uploaded={!!fileId}
        data-file-name={fileName}
      >
        <Row onClick={onClickStopPropagation} alignItems="center" justifyContent="between">
          <Col col>
            <FileNameWrapper
              hasHover
              onClick={() => {
                onDownloadFile(fileId, fileName, mimeType)
              }}
            >
              <FileTypeIcon type={mimeType} height={18} width={16} />
              <FileName>{fileName}</FileName>
            </FileNameWrapper>
          </Col>
        </Row>
      </Wrapper>
    )}
  </DocumentContext.Consumer>
)

FileEntry.propTypes = propTypes
FileEntry.defaultProps = defaultProps

export default FileEntry
